var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectSankeyChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2872_17825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.30078 3L3.40078 3V3.53333L3.40078 4.56667L3.40078 5.1L1.30078 5.1V4.56667L1.30078 3.53333L1.30078 3Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30078 10.9004H3.40078V11.4337L3.40078 12.4671L3.40078 13.0004H1.30078V12.4671L1.30078 11.4337L1.30078 10.9004Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 3L9.00039 3V3.53333V4.56667L9.00039 5.1H6.90039V4.56667V3.53333V3Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90039 10.9004H9.00039V11.4337V12.4671L9.00039 13.0004H6.90039V12.4671V11.4337V10.9004Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5996 6.90039L14.5996 9.00039L14.0663 9.00039L13.0329 9.00039L12.4996 9.00039L12.4996 6.90039L13.0329 6.90039L14.0663 6.90039L14.5996 6.90039Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79693 8.02119L7.88215 10.6004M9.79693 8.02119L7.88215 5.40039M9.79693 8.02119H4.21557M9.79693 8.02119H12.0008M4.21557 8.02119L2.30078 10.6004M4.21557 8.02119L2.30078 5.40039",
    stroke: "#000000",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2872_17825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectSankeyChart);
export default __webpack_public_path__ + "static/media/Select_SankeyChart.a657572ae568943c524e8f78d24a91eb.svg";
export { ForwardRef as ReactComponent };